import React from 'react';
import { Link } from 'react-router-dom';
import './AdPlaceholder.css';

interface AdPlaceholderProps {
  type: 'trending' | 'tips' | 'stats';
  position: 'left' | 'right';
}

const AdPlaceholder: React.FC<AdPlaceholderProps> = ({ type, position }) => {
  const renderContent = () => {
    switch (type) {
      case 'trending':
        return (
          <div className="ad-content">
            <h4>🔥 Trending Categories</h4>
            <ul className="trending-list">
              <li>
                <Link to="/categories">Electronics</Link>
              </li>
              <li>
                <Link to="/categories">Fashion</Link>
              </li>
              <li>
                <Link to="/categories">Home & Garden</Link>
              </li>
              <li>
                <Link to="/categories">Sports</Link>
              </li>
              <li>
                <Link to="/categories">Books</Link>
              </li>
            </ul>
            <Link to="/categories" className="view-all-link">
              View All →
            </Link>
          </div>
        );

      case 'tips':
        return (
          <div className="ad-content">
            <h4>💡 Deal Tips</h4>
            <ul className="tips-list">
              <li>Check deal scores for quality</li>
              <li>Compare prices before buying</li>
              <li>Read user comments</li>
              <li>Set up deal alerts</li>
              <li>Follow top contributors</li>
            </ul>
          </div>
        );

      case 'stats':
        return (
          <div className="ad-content">
            <h4>📊 Community Stats</h4>
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-number">1,247</span>
                <span className="stat-label">Active Deals</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">$2.3M</span>
                <span className="stat-label">Saved Today</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">15,892</span>
                <span className="stat-label">Happy Users</span>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className="ad-content">
            <h4>🎯 Ad Placeholder</h4>
            <p>
              This is a test placeholder for {type} at {position} position.
            </p>
          </div>
        );
    }
  };

  return <div className={`ad-placeholder ad-placeholder-${position}`}>{renderContent()}</div>;
};

export default AdPlaceholder;
